import { gql } from '@apollo/client';
import { Question } from '../../types';

export type QuestionGroup = {
  id: string;
  no: number;
  name: string;
  questions: Question[];
};

type Request = {
  id: string;
  comment: string;
  employee: Employee;
  actedUser: ActedUser;
  updatedAt: string;
};

type Employee = {
  id: string;
  status: string;
};

type ActedUser = {
  id: string;
  name: string;
};

export type QueryResult = {
  questionGroups: QuestionGroup[];
  request: Request;
};

export const FETCH_EMPLOYEE_QUESTIONS = gql`
  query questions {
    questionGroups {
      id
      no
      name
      questions {
        id
        name
        status
        code
        no
        questionDescriptions {
          id
          questionId
          field
          name
          description
        }
        requestQuestion {
          id
          status
        }
      }
    }
  }
`;
